import { environment } from '@env/environment';

interface VersionInfo {
  version?: string;
}

export async function readAppVersion(fallback: string | null = null): Promise<string | null> {
  const frontendVersion = await readVersionFrom(`/version.json?v=${Date.now()}`);

  if (frontendVersion) {
    return frontendVersion;
  }

  const backendVersion = await readVersionFrom(`${environment.apiUrl}/version`);

  return backendVersion || fallback;
}

async function readVersionFrom(url: string): Promise<string | null> {
  try {
    const response = await fetch(url, { cache: 'no-store' });

    if (!response.ok) {
      return null;
    }

    const versionInfo = (await response.json()) as VersionInfo;
    return versionInfo.version || null;
  } catch {
    return null;
  }
}
